/* eslint-disable no-return-assign */
import React, { useEffect, useState } from 'react';

// Redux
import { useSelector } from 'react-redux';

// Material UI
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

// Material Icons
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

// Helpers
import { currencyFormat } from 'helpers/currencyFormat';

// Types
import { ApplicationState } from 'store';
import { EmtuReportDataInterface } from 'store/ducks/reports/types';
// Constants
import IMAGES from 'constants/images';

// Components
import { DialogueExport } from 'components';
import { Row } from '../Row';

// Styles
import useStyles from './tableEmtuReport.styles';

interface StateProps {
  setTableCSV: (arg: any) => void;
  csvRef: any;
  tableReference: null | ((arg: any) => void);
  emtuList?: EmtuReportDataInterface[];
}

type Props = StateProps;

const TableEmtuReport: React.FC<Props> = ({
  setTableCSV,
  csvRef,
  tableReference,
  emtuList,
}) => {
  const classes = useStyles();

  const [openCollapseAll, setOpenCollapseAll] = useState(true);
  const emtuReportList = useSelector((state: ApplicationState) =>
    emtuList && emtuList.length ? emtuList : state.reports.emtuReportList.data,
  );
  const emtuReportCsv = useSelector(
    (state: ApplicationState) => state.reports.emtuReportList.csv,
  );

  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );

  const transportOperatorsList = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorsList,
  );

  useEffect(() => {
    let csv = '';
    if (emtuReportList?.length > 0) {
      const header =
        'Nome Usuário;Data;Qtd. Comprada;Valor Comprado;Qtd. Utilizada;Valor Utilizado;Total;\n';

      csv += header;

      emtuReportList.forEach((user) =>
        user?.monthsResult?.forEach((item) => {
          csv += `${user.user};${item.month};${item.buys};${
            item.buyValue ? currencyFormat({ value: item.buyValue }) : '-'
          };${item.usages};${
            item.usageValue ? currencyFormat({ value: item.usageValue }) : '-'
          };${currencyFormat({ value: item.buyValue - item.usageValue })};\n`;

          csv += `Saldo; ; ; ; ; ;${currencyFormat({
            value: user?.balance || 0,
          })};\n`;
        }),
      );
    }

    setTableCSV(csv);
  }, [setTableCSV, emtuReportList]);

  let total = 0;
  emtuReportList.forEach((user) => (total += user.balance));

  return (
    <>
      <Grid
        container
        justifyContent='flex-end'
        className={classes.gridContainer}>
        <Grid container justifyContent='flex-end' alignItems='center'>
          <Box display='flex' alignItems='center'>
            <Box className={classes.resume}>
              <Box className={classes.contentImage}>
                <img src={IMAGES.REPORTS_ICONS.TOTAL_ENTRY} alt='total entry' />
              </Box>
              <Divider
                className={classes.dividerVertical}
                orientation='vertical'
                flexItem
              />{' '}
              <Grid className={classes.contentTotalEntry}>
                <Typography className={classes.subTiltle}>
                  Saldo total
                </Typography>
                <Typography className={classes.value}>
                  {currencyFormat({ value: total })}
                </Typography>
              </Grid>
            </Box>
            <DialogueExport
              tableInstance={tableReference}
              csvRef={csvRef}
              pdfName='página relatório EMTU'
              pdf
              csv
            />
          </Box>
        </Grid>
      </Grid>
      <Box m={2}>
        <TableContainer className={classes.table}>
          <Table aria-label='collapsible table'>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Box
                    display='flex'
                    alignItems='center'
                    justifyContent='space-between'>
                    <Typography>Nome Usuário</Typography>
                  </Box>
                </TableCell>
                <TableCell>Data</TableCell>
                <TableCell>Qtd. Comprada</TableCell>
                <TableCell>Valor Comprado</TableCell>
                <TableCell>Qtd. Utilizada</TableCell>
                <TableCell>Valor Utilizado</TableCell>
                <TableCell>Total</TableCell>
                {transportOperatorSelected.type === 1 && (
                  <TableCell>Operação</TableCell>
                )}
                <TableCell>
                  <Box
                    display='flex'
                    alignItems='center'
                    justifyContent='space-between'>
                    <Box display='flex' alignItems='center'>
                      <IconButton
                        aria-label='expand row'
                        size='small'
                        onClick={() => setOpenCollapseAll((o) => !o)}>
                        {openCollapseAll ? (
                          <KeyboardArrowUpIcon style={{ color: '#fff' }} />
                        ) : (
                          <KeyboardArrowDownIcon style={{ color: '#fff' }} />
                        )}
                      </IconButton>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableHead>
            {Array.isArray(emtuReportList) &&
              emtuReportList.length > 0 &&
              emtuReportList.map((report, index) => (
                <Row
                  report={report}
                  index={index}
                  openCollapseAll={openCollapseAll}
                />
              ))}
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export { TableEmtuReport };
export default TableEmtuReport;
